export default "__VITE_ASSET__a4531e79__"